'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _RTE = require('../components/RTE');

var _RTE2 = _interopRequireDefault(_RTE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticPage = function () {
  function StaticPage(section) {
    (0, _classCallCheck3.default)(this, StaticPage);

    this.el = section.el;
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    for (var i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new _RTE2.default(this.rteEls[i]));
    }
  }

  (0, _createClass3.default)(StaticPage, [{
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      this.rtes.forEach(function (rte) {
        return rte.unload();
      });
    }
  }]);
  return StaticPage;
}();

exports.default = StaticPage;